export const FERFI = 1;
export const NO = 2;
export const CEG = 3;

export const STATUSZ = {
    TARIFA_ADATOK: 50,
    DIJAJANLAT: 100,
    AJANLAT_KITOLTES: 200,
    AJANLAT: 300,
    FELADOTT: 600,
    TELJESEN_KESZ: 1000,
};

export const TOMBHAZ = 1;
export const KGFB = 2;
export const LAKAS = 3;
export const CASCO = 4;
export const NYUGDIJ = 5;
export const UTAS = 6;
export const ELET = 7;
export const LAKASBR = 8;
export const GYORSHAJTAS = 9;
export const GEPTORES = 10;
export const CSOPORTOSELET = 11;
export const CARKERET = 12;
export const CAR = 13;
export const ALTFEL = 14;
export const VVAGYON = 15;
export const EGYEB = 16;
export const SZFEL = 17;
export const KISVALL = 18;
export const UUTITARS = 19;
export const MAPFREA = 20;
export const KGFBC = 21;
export const MAPFREK = 22;
export const BALESET = 23;
export const MED = 24;
export const GAP = 25;

export const ALAIRT_TELJESKORU_MEGBIZASI = 1;
export const ALART_MEGBIZASI = 2;
export const ALAIRT_UGYFEL_TAJEKOZTATO = 3;
export const EGYEB_DOKUEMNTUM = 4;
export const FELMONDAS_UGYFEL_ALAIRT = 5;
export const FELMONDAS_ALKUSZ_ALAIRT = 6;
export const ALAIRT_AJALNAT = 7;

export const EVFORDULO = 1;
export const UJ = 2;
export const HASZNALT = 3;
export const KULFOLDI = 4;
export const UZEMBENTARTO_VALT = 5;
export const DNF = 6;
export const KOZOS_MEGEGYEZES = 7;
export const KIVONT = 8;
export const OROKLES = 9;

export const UJ_BELEPO = 1;
export const NEM_UJ_BELEPO = 2;
export const PARHUZAMOS_SZERZODES = 3;

export const GEPJARMU_ESEMENY = {
    NEM_TORTENT: 'nem_tortent',
    TOTALKAR: 'totalkar',
    KAROSSZERIA_SERULES: 'karosszeria-serules',
    MOTOCSERE: 'motorcsere',
    KAROSSZERIA_CSERE: 'karosszeria_csere',
    NINCS_TUDOMASOM_ROLA: 'nincs_tudomasom_rola',
};

export const MINDEN_MODOZAT = [
    TOMBHAZ, KGFB, KGFBC, LAKAS, CASCO, NYUGDIJ,
    UTAS, ELET, LAKASBR, GYORSHAJTAS,
    GEPTORES, CSOPORTOSELET, CARKERET, CAR,
    ALTFEL, VVAGYON, EGYEB, SZFEL, KISVALL,
    UUTITARS, MAPFREA, MAPFREK, BALESET, MED,
];

export const EVFORDULO_NYILATKOZAT = 1;
export const MENTES_NYILATKOZAT = 2;
export const HARMADIK_OLDAL_MENTES_NYILATKOZAT = 2;

export const ORDER_INSURER_NAME_ASC = 1;
export const ORDER_INSURER_NAME_DESC = 2;
export const ORDER_KGFB_PRICE_ASC = 3;
export const ORDER_KGFB_PRICE_DESC = 4;
export const ORDER_CASCO_PRICE_ASC = 5;
export const ORDER_CASCO_PRICE_DESC = 6;
export const ORDER_EGYUTT_PRICE_ASC = 7;
export const ORDER_EGYUTT_PRICE_DESC = 8;
